import { InfoOutlined } from '@mui/icons-material'
import { Avatar, Box, Card, CardContent, CardHeader, Divider, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function ShippingCompanyCard({ selectedCompany }) {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader
                avatar={
                    <Avatar
                        sx={{ width: 60, height: 60 }}
                        variant='square'
                        src={selectedCompany?.logo}
                        aria-label="recipe"
                    />
                }
                title={selectedCompany?.deliveryOptionName}
                subheader={selectedCompany?.serviceType}
                action={
                    <Typography variant="h4">
                        {`${selectedCompany?.price} ${t(`currency.${selectedCompany?.currency}`)}`}
                    </Typography>
                }
            />
            <Divider />
            <CardContent>
                <Grid container spacing={2}>
                    {
                        !!selectedCompany?.liabilityAmount &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.shippingCompany.Liability")}
                                    </Typography>
                                    <Tooltip title={t("shippingDetails.shippingCompany.LiabilityInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {`${t("up to")} ${selectedCompany?.liabilityAmount} ${t(`currency.${selectedCompany?.currency}`)}`}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    {
                        !!selectedCompany?.pickupCutOffTime &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.shippingCompany.pickupCutoffTime")}
                                    </Typography>
                                    <Tooltip title={t("shippingDetails.shippingCompany.pickupCutoffTimeInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {t(`shippingDetails.shippingCompany.pickupCutoffTimeValue`, { value: selectedCompany?.pickupCutOffTime })}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}
